import { render, staticRenderFns } from "./MyTasksWidget.vue?vue&type=template&id=33b62f13&scoped=true"
import script from "./MyTasksWidget.vue?vue&type=script&lang=js"
export * from "./MyTasksWidget.vue?vue&type=script&lang=js"
import style0 from "./MyTasksWidget.vue?vue&type=style&index=0&id=33b62f13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b62f13",
  null
  
)

export default component.exports